import MedicalEquipmentPageState from "@GeriMed/Store/Pages/MedicalEquipment/MedicalEquipmentState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";

const initialState: MedicalEquipmentPageState = {
    getMedicalEquipmentParameter: {
        customerNumber: "",
    }
};
const reducer = {};

const medicalEquipmentPageReducer = createTypedReducerWithImmer(initialState,reducer);

(reducers as any).medicalEquipmentPageState = medicalEquipmentPageReducer;
